export const AuthErrorCode = {
  EMAIL_INVALID: 'EMAIL_INVALID',
  EMAIL_CONFIRMATION_REQUIRED: 'EMAIL_CONFIRMATION_REQUIRED',
  EMAIL_MISMATCH: 'EMAIL_MISMATCH',
  PASSWORD_TOO_SHORT: 'PASSWORD_TOO_SHORT',
} as const;

export type AuthErrorCode = (typeof AuthErrorCode)[keyof typeof AuthErrorCode];
